/**
 * /tenants/{slug}/oauth-dynreg — legacy redirect.
 *
 * Dynamic Registration was previously a top-level sidebar
 * entry with its own URL space (`/oauth-dynreg`). On the
 * senior-UX-designer pass it became a tab under Applications
 * (Dynamic Registration is a *property of how applications get
 * created*, not a peer of the Applications list — see the
 * ApplicationsTabs component header for the IA rationale).
 *
 * This route exists solely to redirect any bookmark, deep
 * link, or stale page reload to the new canonical URL:
 *
 *   /tenants/{slug}/oauth-dynreg
 *     → /tenants/{slug}/settings/automated-onboarding
 *
 * Search params are forwarded verbatim so a bookmark of
 * `/oauth-dynreg?include_revoked=true` lands on the same
 * filter state under the new path.
 *
 * Keep this redirect for at least one release cycle. Operators
 * who'd cached the old URL in their browser history shouldn't
 * hit a 404; the redirect keeps the upgrade silent.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Same search schema as the new route so we can preserve
// `include_revoked` through the redirect. Not `.strict()` — the
// route can be hit with stray params (UTM tags, deep links from
// older surfaces) and we forward whatever lands.
const searchSchema = z.object({
  include_revoked: z.boolean().optional(),
});

export const Route = createFileRoute("/_authed/tenants/$slug/oauth-dynreg")({
  validateSearch: (raw: Record<string, unknown>) => searchSchema.parse(raw),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/tenants/$slug/settings/automated-onboarding",
      params: { slug: params.slug },
      search,
      replace: true,
    });
  },
});
